"use strict";

exports.__esModule = true;
exports.default = sortAscending;
function sortAscending(list) {
    return list.sort(function (a, b) {
        return a - b;
    });
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/postcss-attribute-case-insensitive/~/postcss-selector-parser/dist/sortAscending.js
 ** module id = 280
 ** module chunks = 0
 **/